<template>

    <div class="atu-modal" id="atuModalWelcome" style="display: block;">
        <div class="atu-modal__center">
            <div class="atu-modal__content">
                <div class="atu-modal__head" style="display: none;">
                    <div class="atu-modal__close"><i class="atuicons atuicons-close"></i></div>
                </div>
                <form class="atu-modal__body" @submit.prevent="handleSumbmit()">
                    <div class="atu-modal-steps">
                        <div v-if="showFirstStep" class="atu-modal-step atu-modal-step-visible"
                            id="atuModalWelcomeStep1">
                            <div class="atu-modal__title">WHAT TYPE OF SKATER ARE YOU?</div>
                            <div class="atu-body-types">
                                <label class="atu-body-type"><input type="radio" v-model="form.bodyType"
                                        value="solo-female">
                                    <div class="atu-body-type__button">
                                        <div class="atu-body-type__img"><img :src="require(`@/assets/img/skate-quiz-single-female.png`)">
                                        </div>
                                        <div class="atu-body-type__title">Solo - Female</div>
                                    </div>
                                </label>
                                <label class="atu-body-type"><input type="radio" v-model="form.bodyType"
                                        value="pair-female">
                                    <div class="atu-body-type__button">
                                        <div class="atu-body-type__img"><img :src="require(`@/assets/img/skate-quiz-pair-female.png`)"></div>
                                        <div class="atu-body-type__title">Pair - Female</div>
                                    </div>
                                </label>
                                <label class="atu-body-type"><input type="radio" v-model="form.bodyType"
                                        value="synchro-female">
                                    <div class="atu-body-type__button">
                                        <div class="atu-body-type__img"><img
                                            :src="require(`@/assets/img/skate-quiz-synchronized-female.png`)"
                                        ></div>
                                        <div class="atu-body-type__title">Synchro - Female</div>
                                    </div>
                                </label>
                                <label class="atu-body-type"><input type="radio" v-model="form.bodyType"
                                        value="solo-male">
                                    <div class="atu-body-type__button">
                                        <div class="atu-body-type__img"><img 
                                            :src="require(`@/assets/img/skate-quiz-single-male.png`)"
                                            >
                                        </div>
                                        <div class="atu-body-type__title">Solo - Male</div>
                                    </div>
                                </label>
                                <label class="atu-body-type"><input type="radio" v-model="form.bodyType"
                                        value="pair-male">
                                    <div class="atu-body-type__button">
                                        <div class="atu-body-type__img">
                                            <img :src="require(`@/assets/img/skate-quiz-pair-male.png`)"></div>
                                        <div class="atu-body-type__title">Pair - Male</div>
                                    </div>
                                </label>
                                <label class="atu-body-type"><input type="radio" v-model="form.bodyType"
                                        value="synchro-male">
                                    <div class="atu-body-type__button">
                                        <div class="atu-body-type__img"><img :src="require(`@/assets/img/skate-quiz-synchronized-male.png`)"
                                          >
                                        </div>
                                        <div class="atu-body-type__title">Synchro - Male</div>
                                    </div>
                                </label>
                            </div>
                            <div class="atu-modal__buttons">
                                <button key="nextStepButton" :disabled="this.form.bodyType.length === 0" class="button button_red" href="#"
                                    @click="showSecondStepHandler">Next Step</button>
                            </div>
                        </div>
                        <div v-if="showSecondStep" class="atu-modal-step atu-modal-step-visible"
                            id="atuModalWelcomeStep2">
                            <div class="atu-modal__title">Pick Your Workout Intensity</div>
                            <div class="atu-modal-radios">
                                <label class="atu-modal-radio">
                                    <input type="radio" v-model="form.frequency" value="3"><span>3 days per week</span>
                                </label>
                                <label class="atu-modal-radio">
                                    <input type="radio" v-model="form.frequency" value="4"><span>4 days per week</span>
                                </label>
                                <label class="atu-modal-radio">
                                    <input type="radio" v-model="form.frequency" value="5"><span>5 days per week</span>
                                </label>
                            </div>
                            <div class="atu-modal__buttons">
                                <button key="atuModalWelcomeStep2Back" :disabled="this.isLoading" class="button button_black"
                                    @click="showFirstStepHandler">GO BACK</button>
                                <button key="atuModalWelcomeStep2Submit" :disabled="this.form.frequency.length === 0 || this.isLoading" type="submit"
                                    class="button button_red">{{ this.isLoading ? "Please wait..." : 'SUBMIT' }}</button>
                            </div>
                        </div>
                        <div v-if="showThirdStep" class="atu-modal-step atu-modal-step-visible"
                            id="atuModalWelcomeStep3">
                            <div class="skate-you-did-it">
                                <div class="skate-you-did-it__img"><img :src="require(`@/assets/img/skate-you-did-it.png`)"></div>
                                <div class="skate-you-did-it__text">
                                    <div class="atu-modal__title">You did it!</div>
                                    <div class="atu-modal__text"> You're officially on the path to stronger, sharper
                                        skating. This is your first step toward your Olympic journey.</div>
                                </div><a class="button button_red" href="#" @click="goToWorkoutPlan">View Your Workout
                                    Plan</a>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<style scoped>
@import "~@/assets/css/popups.css";
@import "~@/assets/css/quiz.css";
</style>


<script>
import NProgress from "nprogress";
import { updateInfo } from '@/api/user';

export default {
    name: "QuizModal",
    data() {
        return {
            form: {
                bodyType: "",
                frequency: "",
            },
            showFirstStep: true,
            showSecondStep: false,
            showThirdStep: false,
            isLoading: false
        };
    },
    methods: {
        showFirstStepHandler() {
            this.showFirstStep = true;
            this.showSecondStep = false;
            this.showThirdStep = false;
        },
        showSecondStepHandler() {
            if (this.form.bodyType.trim().length === 0) {
                alert('Please select your body type');
                return;
            }
            this.showFirstStep = false;
            this.showSecondStep = true;
            this.showThirdStep = false;
        },

        showThirdStepHandler() {
            console.log('show third step');
            this.showFirstStep = false;
            this.showSecondStep = false;
            this.showThirdStep = true;
        },

        handleSumbmit() {
            if (this.form.bodyType.trim().length === 0 || this.form.frequency.trim().length === 0) {
                alert('Please select your body type and workout frequency');
                return;
            }
            NProgress.start();
            this.isLoading = true;
            const bodyType = this.form.bodyType;
            const frequency = this.form.frequency;
            updateInfo({ bodyType, frequency })
                .then(() => {
                    this.showThirdStepHandler();
                }).catch(error => {
                    console.log("error", error);
                }).finally(() => {
                    NProgress.done();
                    this.isLoading = false;
                });
        },

        goToWorkoutPlan() {
            if (this.$route.path !== "/workout/index") {
                this.$router.push({ path: "/workout/index" }).then(() => {
                    window.location.reload();
                });
            }else{
                window.location.reload();
            }
        }
    }
};
</script>